<template>
  <div class="yiyobackground">
    <img class="yiyoimg1" src="../assets/images/logo.jpg">
    <img class="yiyoimg2" src="../assets/images/logo.jpg">
    <img class="yiyoimg3" src="../assets/images/logo.jpg">
    <img class="yiyoimg4" src="../assets/images/logo.jpg">
    <img class="yiyoimg5" src="../assets/images/logo.jpg">
    <img class="yiyoimg6" src="../assets/images/logo.jpg">
    <img class="yiyoimg7" src="../assets/images/logo.jpg">
    <img class="yiyoimg8" src="../assets/images/logo.jpg">
    <img class="yiyoimg9" src="../assets/images/logo.jpg">
    <img class="yiyoimg10" src="../assets/images/logo.jpg">
    <img class="yiyoimg11" src="../assets/images/logo.jpg">
    <img class="yiyoimg12" src="../assets/images/logo.jpg">
    <img class="yiyoimg13" src="../assets/images/logo.jpg">
    <div class="contenttext">
      <span>All-in-one tool for people-powered translation.</span>
      <p>A more elaborate description of the product that wraps to the second line</p>
      <el-button :plain="true" @click.native="getStart()" >Get Started — for free</el-button>
    </div>
  </div>
</template>

<script>
import {mapState,mapMutations} from 'vuex'
export default {
  name: 'top',
  data () {
    return {
      msg: '',
      lang:'zh-CN',
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      
    })
  },
  computed: {
  },
  methods: {
    getStart(){},
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
html{
  font-size: 625%;
}
.yiyobackground{
  position: relative;
  /*width: 6.04rem;
  height: 5.88rem;
  display:inline-block;
  display:table-cell;
  vertical-align:middle;
  display: block;
  bottom:-0.2rem;*/
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  height: 5.88rem;
}
.yiyobackground .yiyoimg1{
  position: absolute;
  width: 0.59rem;
  height: 0.53rem;
  left: 5.20rem;
  top: 3.90rem;
  mix-blend-mode: darken;
  /*opacity: 0.1;*/
  margin-top: -1.65rem;
}
.yiyobackground .yiyoimg2{
  position: absolute;
  width: 0.67rem;
  height: 0.64rem;
  left: 5.79rem;
  top: 5.45rem;
  margin-top: -1.65rem;
}
.yiyobackground .yiyoimg3{
  position: absolute;
  width: 0.59rem;
  height: 0.53rem;
  left: 0.98rem;
  top: 6.92rem;
  mix-blend-mode: darken;
  margin-top: -1.65rem;
}
.yiyobackground .yiyoimg4{
  position: absolute;
  width: 0.73rem;
  height: 0.57rem;
  left: 2.67rem;
  top: 2.01rem;
  margin-top: -1.65rem;
}
.yiyobackground .yiyoimg5{
  position: absolute;
  width: 0.68rem;
  height: 0.64rem;
  left: 0.89rem;
  top: 1.65rem;
  margin-top: -1.65rem;
}
.yiyobackground .yiyoimg6{
  position: absolute;
  width: 0.67rem;
  height: 0.64rem;
  left: 4.47rem;
  top: 1.68rem;
  margin-top: -1.65rem;
}
.yiyobackground .yiyoimg7{
  position: absolute;
  width: 0.44rem;
  height: 0.41rem;
  left: 2.00rem;
  top: 6.98rem;
  margin-top: -1.65rem;
}
.yiyobackground .yiyoimg8{
  position: absolute;
  width: 0.44rem;
  height: 0.41rem;
  left: 0.42rem;
  top: 3.49rem;
  margin-top: -1.65rem;
}
.yiyobackground .yiyoimg9{
  position: absolute;
  width: 0.44rem;
  height: 0.41rem;
  left: 3.93rem;
  top: 4.23rem;
  margin-top: -1.65rem;
}
.yiyobackground .yiyoimg10{
  position: absolute;
  width: 0.73rem;
  height: 0.57rem;
  left: 5.63rem;
  top: 2.45rem;
  margin-top: -1.65rem;
}
.yiyobackground .yiyoimg11{
  position: absolute;
  width: 0.73rem;
  height: 0.57rem;
  left: 5.19rem;
  top: 6.96rem;
  margin-top: -1.65rem;
}
.yiyobackground .yiyoimg12{
  position: absolute;
  width: 0.68rem;
  height: 0.64rem;
  left: 3.25rem;
  top: 6.89rem;
  margin-top: -16.5rem;
}
.yiyobackground .yiyoimg13{
  position: absolute;
  width: 0.59rem;
  height: 0.53rem;
  left: -0.25rem;
  top: 4.65rem;
  margin-top: -1.65rem;
  mix-blend-mode: darken;
}
.yiyobackground .contenttext{
  position: absolute;
  /*width: 5.05rem;
  height: 3.82rem;
  left: 1.13rem;
  top: 1.53rem;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  display: inline-block;*/
  width: 90% ;
  text-align:left;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  color: #000000;
}
@media only screen and (max-width: 1000px) {
  .yiyobackground {width: 6.04rem; height: 5.88rem; margin: 0 auto;}
  .yiyobackground .contenttext {width: 5.05rem; height: 3.82rem}
}
@media only screen and (max-width: 768px){
  .yiyobackground {width: 100%!important; height: 5.88rem; margin: 0 auto;}
  .yiyobackground .contenttext {width: 100%!important; height: 3.82rem}
  .yiyobackground .contenttext span{font-size: 0.36rem!important;}

}
.yiyobackground .contenttext span{
  /*width: 6.05rem;
  height: 1.77rem;
  line-height: 0.59rem;*/
  width: 98%;
  height: 1.77rem;
  line-height: 0.59rem;
  font-size: 0.48rem;
}
.yiyobackground .contenttext p{
  /*width: 4.97rem;
  height: 0.64rem;*/
  width: 98%;
  font-size: 0.26rem;
  line-height: 0.32rem;
  margin-top: 0.36rem;
}
.yiyobackground .contenttext .el-button{
  align-items: center;
  /*padding: 0.18rem 0.62rem;
  width: 3.68rem;
  height: 0.63rem;*/
  margin-top: 0.42rem;
  background: #222222;
  box-shadow: 0rem 0.04rem 0.10rem rgba(0, 0, 0, 0.1);
  border-radius: 0.10rem;
  font-weight: 500;
  font-size: 0.22rem;
  line-height: 0.27rem;
  width: 95%;
  height: auto;
  padding: 20px 0;
  white-space: pre-wrap;
  color:#ffffff;
}
.yiyobackground .contenttext .el-button:hover{
  opacity:0.9;
  border-color:#000;
}
</style>




// WEBPACK FOOTER //
// src/components/YiyoBackground.vue